import React, { useEffect } from 'react';
import { Chart as ElementChart } from 'react-chartjs-2';
import Chart, { ChartData } from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import "../styles.css"

interface Props {
    titleGraph: string;
    dataColumn: LabelElement[];
    dataLine: LabelElement[];
    colorIcons: string[];
    axisLabels?: string[];
    fullWidth?: boolean;
    exportPDF?: boolean;
    tooltipLabels?: string[];
    tooltipValues?: string[];
    info?: any[];
}

interface LabelElement {
    label: string[] | string;
    value: number;
}

const ChartBarLine: React.FC<Props> = ({ titleGraph, colorIcons, dataColumn, dataLine, axisLabels, fullWidth, exportPDF, tooltipLabels, tooltipValues, info }) => {
    Chart.register(ChartDataLabels);
    Chart.defaults.font.size = 12;

    const charData: ChartData = {
        labels: dataColumn ? dataColumn.map((el) => el.label) : [],
        datasets: [
            {
                type: 'bar',
                label: colorIcons[0],
                backgroundColor: "#57CE71",
                data: dataColumn ? dataColumn.map((el) => Number((typeof (el.value) == "number" ? el.value : 0).toPrecision(2))) : [],
                borderWidth: 1,
                yAxisID: 'y1',
                order: 1
            },
            {
                type: 'line',
                label: colorIcons[1],
                backgroundColor: "#FF9501",
                borderColor: "#FF9501",
                data: dataLine ? dataLine.map((el) => Number((typeof (el.value) == "number" ? el.value : 0).toPrecision(2))) : [],
                borderWidth: 2,
                yAxisID: 'y2',
                order: 0
            }
        ],
    };

    return (
        <div>
            <span className='titleGraph'>{titleGraph}</span>
            <div className={`contentGraphBorder ${fullWidth ? `containerGraphFull${exportPDF ? "-print" : ""}` : ""}`}>
                {dataColumn && dataColumn.every((el: any) => el?.value === 0) && dataLine.every((el: any) => el?.value === 0) ?
                    <div className='noData'>
                        <span>Sem dados</span>
                    </div>
                    :
                    <>
                        <ElementChart
                            className={`${fullWidth ? "fullWidth" : ""}`}
                            type='bar'
                            data={charData}
                            options={{
                                devicePixelRatio: 4,
                                animation: {
                                    duration: 0
                                },
                                plugins: {
                                    legend: {
                                        display: true,
                                        position: 'bottom',
                                        reverse: true,
                                        labels: {
                                            boxWidth: 10,
                                        },
                                    },
                                    datalabels: {
                                        display: "auto",
                                        anchor: "end",
                                        align: "start",
                                        offset: -20,
                                        font: {
                                            size: 10,
                                            weight: "bold"
                                        },
                                    },
                                    tooltip: {
                                        enabled: true,
                                        mode: 'index',
                                        intersect: false,
                                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                                        titleColor: '#fff',
                                        bodyColor: '#fff',
                                        borderColor: '#fff',
                                        borderWidth: 1,
                                        displayColors: false,
                                        callbacks: {
                                            title: function (context) {
                                                return tooltipLabels && tooltipLabels[context[0].dataIndex]
                                                    ? tooltipLabels[context[0].dataIndex]
                                                    : context[0].label;
                                            },
                                            label: function (context) {
                                                if (info && Array.isArray(info) && info[context.dataIndex]) {
                                                    const microAreas = info[context.dataIndex];
                                                    if (Array.isArray(microAreas)) {
                                                        if (context.datasetIndex === 0) { // Bar chart
                                                            return microAreas.map((microArea: any) => {
                                                                const value = microArea.value !== null ? microArea.value : '0';
                                                                return `${microArea.initials}: ${value}`;
                                                            });
                                                        } else {
                                                            return '';
                                                        }
                                                    }
                                                }

                                                if (tooltipLabels && tooltipValues) {
                                                    const labelIndex = context.dataIndex;
                                                    const label = tooltipLabels[labelIndex] || context.dataset.label || '';
                                                    const value = tooltipValues[labelIndex] || context.parsed.y;
                                                    return `${label}: ${value}`;
                                                }

                                                const label = context.dataset.label || '';
                                                const value = context.parsed.y;
                                                return `${label}: ${value}`;
                                            }
                                        }
                                    },
                                },
                                layout: {
                                    padding: {
                                        top: 30,
                                        right: 2
                                    }
                                },
                                scales: {
                                    x: {
                                        grid: {
                                            display: false,
                                        },
                                        title: {
                                            display: !!axisLabels,
                                            text: axisLabels ? axisLabels[0] : "",
                                            font: {
                                                size: 12,
                                            },
                                        }
                                    },
                                    y1: {
                                        type: 'linear',
                                        display: true,
                                        position: 'left',
                                        title: {
                                            display: !!axisLabels,
                                            text: axisLabels ? axisLabels[1] : "",
                                            font: {
                                                size: 12,
                                            },
                                        }
                                    },
                                    y2: {
                                        type: 'linear',
                                        display: true,
                                        position: 'right',
                                        grid: {
                                            drawOnChartArea: false,
                                        },
                                        title: {
                                            display: !!axisLabels,
                                            text: axisLabels ? axisLabels[2] : "",
                                            font: {
                                                size: 12,
                                            },
                                        }
                                    }
                                },
                            }}
                            width={1360}
                            height={500}
                        />
                    </>
                }
            </div>
        </div>
    )
};

export default ChartBarLine;